import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { FournisseurAgreeDTO } from '../model/fournisseuragree/fournisseur-agree-dto';
import { CreateFournisseurAgree } from '../model/fournisseuragree/create-fournisseur-agree';
import { UpdateFournisseurAgree } from '../model/fournisseuragree/update-fournisseur-agree';
import { UpdateExpositionNette } from '../model/fournisseuragree/update-exposition-nette';

@Injectable({
    providedIn: 'root'
  })
  export class FournisseurAgreeService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    findAll() 
    {
        return this._restClientService.load<FournisseurAgreeDTO[]>('fournisseur-agree/find-all');
    }

    findById(id) 
    {
        return this._restClientService.load<FournisseurAgreeDTO>('fournisseur-agree/find-by-id/'+id);
    }
    
    add(createFournisseurAgree: CreateFournisseurAgree ) 
    {
        return  this._restClientService.save<CreateFournisseurAgree>('fournisseur-agree/add', createFournisseurAgree);
    }
    
    update(updateFournisseurAgree: UpdateFournisseurAgree ) 
    {
        return  this._restClientService.put<UpdateFournisseurAgree>('fournisseur-agree/update', updateFournisseurAgree);
    }
       
    updateExpositionNette(updateExpositionNette: UpdateExpositionNette ) 
    {
        return  this._restClientService.put<UpdateFournisseurAgree>('fournisseur-agree/update-exposition-nette', updateExpositionNette);
    }
}      

    